import type { ManeuverCode } from "../../constants/lessonReportCatalog";

/** PNG ikonlar: frontend/public/images/lesson-report/maneuvers/ — görsel değişince sürümü artırın */
const MANEUVER_ICON_VERSION = "20260519";

const MANEUVER_ICON_SRC: Record<ManeuverCode, string> = {
  arac_tanitim_ic_dis: `/images/lesson-report/maneuvers/arac_tanitim_ic_dis.png?v=${MANEUVER_ICON_VERSION}`,
  arac_calistirma_surus_ayari: `/images/lesson-report/maneuvers/arac_calistirma_surus_ayari.png?v=${MANEUVER_ICON_VERSION}`,
  sinyal_kullanim: `/images/lesson-report/maneuvers/sinyal_kullanim.png?v=${MANEUVER_ICON_VERSION}`,
  vites_gecis_debriyaj: `/images/lesson-report/maneuvers/vites_gecis_debriyaj.png?v=${MANEUVER_ICON_VERSION}`,
  dur_kalk_rampa_kalkis: `/images/lesson-report/maneuvers/dur_kalk_rampa_kalkis.png?v=${MANEUVER_ICON_VERSION}`,
  l_park: `/images/lesson-report/maneuvers/l_park.png?v=${MANEUVER_ICON_VERSION}`,
  paralel_park: `/images/lesson-report/maneuvers/paralel_park.png?v=${MANEUVER_ICON_VERSION}`,
  ani_fren: `/images/lesson-report/maneuvers/ani_fren.png?v=${MANEUVER_ICON_VERSION}`,
  geri_surus: `/images/lesson-report/maneuvers/geri_surus.png?v=${MANEUVER_ICON_VERSION}`,
  u_donus_ada_donus: `/images/lesson-report/maneuvers/u_donus_ada_donus.png?v=${MANEUVER_ICON_VERSION}`,
};

export function LessonReportManeuverIcon({ code, className }: { code: ManeuverCode; className?: string }) {
  return (
    <span className={`report-maneuver-icon ${className || ""}`.trim()} aria-hidden>
      <img src={MANEUVER_ICON_SRC[code]} alt="" width={36} height={36} loading="lazy" decoding="async" />
    </span>
  );
}
